/**
 * Toggle 组件 JavaScript
 * 处理 toggle 开关的交互状态和动态行为
 * 支持多页面使用，每个页面可以有多个toggle实例
 */

class ToggleComponent {
  constructor() {
    this.init();
  }

  init() {
    this.setupToggles();
    this.setupEventListeners();
  }

  setupToggles() {
    // 获取所有 toggle 组件
    const toggles = document.querySelectorAll('.component-toggle');
    
    toggles.forEach(toggle => {
      this.setupToggle(toggle);
    });
  }

  setupToggle(toggle) {
    // 移除旧的事件监听器（如果有的话）
    const existingHandler = toggle._toggleHandler;
    if (existingHandler) {
      toggle.removeEventListener('click', existingHandler);
    }
    
    // 创建新的事件处理函数并保存引用
    const handler = this.handleToggleClick.bind(this);
    toggle._toggleHandler = handler;
    
    // 添加 mousedown 事件确保按钮获得焦点
    toggle.addEventListener('mousedown', function(e) {
      e.preventDefault();
      toggle.focus();
    });
    
    toggle.addEventListener('click', handler);
  }

  setupEventListeners() {
    // 监听动态添加的 toggle
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const toggles = node.querySelectorAll ? node.querySelectorAll('.component-toggle') : [];
            if (node.classList && node.classList.contains('component-toggle')) {
              toggles.push(node);
            }
            toggles.forEach(toggle => this.setupToggle(toggle));
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  handleToggleClick(event) {
    const toggle = event.currentTarget;
    const toggleId = toggle.getAttribute('data-toggle');
    const isActive = toggle.getAttribute('data-active') === 'true';
    const newState = !isActive;
    
    // 只触发自定义事件，不更新状态
    // 让页面脚本处理状态更新和API调用
    const customEvent = new CustomEvent('toggleChanged', {
      detail: {
        toggleId: toggleId,
        isActive: newState,
        toggleElement: toggle
      }
    });
    document.dispatchEvent(customEvent);
  }

  // 提供公共方法供页面脚本调用
  updateToggleState(toggleElement, isActive) {
    const svg = toggleElement.querySelector('.component-toggle__svg');
    if (!svg) return;
    
    // 更新data属性
    toggleElement.setAttribute('data-active', isActive.toString());
    
    if (isActive) {
      // Active state
      svg.innerHTML = `
        <path d="M0 12C0 5.37258 5.37258 0 12 0H32C38.6274 0 44 5.37258 44 12C44 18.6274 38.6274 24 32 24H12C5.37258 24 0 18.6274 0 12Z" fill="#ECFDAC"/>
        <rect x="22" y="2" width="20" height="20" rx="10" fill="#293400"/>
        <line x1="12" y1="6" x2="12" y2="18" stroke="#293400" stroke-width="2"/>
      `;
      svg.classList.remove('component-toggle__svg--inactive');
      svg.classList.add('component-toggle__svg--active');
    } else {
      // Inactive state
      svg.innerHTML = `
        <path d="M0 12C0 5.37258 5.37258 0 12 0H32C38.6274 0 44 5.37258 44 12C44 18.6274 38.6274 24 32 24H12C5.37258 24 0 18.6274 0 12Z" fill="#2C2C33"/>
        <rect x="2" y="2" width="20" height="20" rx="10" fill="white"/>
      `;
      svg.classList.remove('component-toggle__svg--active');
      svg.classList.add('component-toggle__svg--inactive');
    }
  }
}

// 全局工具函数，供页面脚本使用
window.ToggleUtils = {
  // 更新指定toggle的状态
  updateToggleState: function(toggleElement, isActive) {
    const svg = toggleElement.querySelector('.component-toggle__svg');
    if (!svg) return;
    
    // 更新data属性
    toggleElement.setAttribute('data-active', isActive.toString());
    
    if (isActive) {
      // Active state
      svg.innerHTML = `
        <path d="M0 12C0 5.37258 5.37258 0 12 0H32C38.6274 0 44 5.37258 44 12C44 18.6274 38.6274 24 32 24H12C5.37258 24 0 18.6274 0 12Z" fill="#ECFDAC"/>
        <rect x="22" y="2" width="20" height="20" rx="10" fill="#293400"/>
        <line x1="12" y1="6" x2="12" y2="18" stroke="#293400" stroke-width="2"/>
      `;
      svg.classList.remove('component-toggle__svg--inactive');
      svg.classList.add('component-toggle__svg--active');
    } else {
      // Inactive state
      svg.innerHTML = `
        <path d="M0 12C0 5.37258 5.37258 0 12 0H32C38.6274 0 44 5.37258 44 12C44 18.6274 38.6274 24 32 24H12C5.37258 24 0 18.6274 0 12Z" fill="#2C2C33"/>
        <rect x="2" y="2" width="20" height="20" rx="10" fill="white"/>
      `;
      svg.classList.remove('component-toggle__svg--active');
      svg.classList.add('component-toggle__svg--inactive');
    }
  },

  // 获取指定toggle的当前状态
  getToggleState: function(toggleElement) {
    return toggleElement.getAttribute('data-active') === 'true';
  },

  // 设置指定toggle的初始状态
  setToggleState: function(toggleElement, isActive) {
    this.updateToggleState(toggleElement, isActive);
  }
};

// 初始化 Toggle 组件
document.addEventListener('DOMContentLoaded', function() {
  new ToggleComponent();
});

// 备用初始化方法
window.addEventListener('load', function() {
  if (!document.querySelector('.component-toggle')) {
    setTimeout(() => {
      new ToggleComponent();
    }, 100);
  }
}); 